import {Component, OnDestroy, OnInit} from '@angular/core';
import {DialogModel} from '@shared/models/dialog.model';
import {InvalidateSubject} from '@shared/helpers/invalidate.subject';
import {BreadcrumbModel} from '@shared/models/breadcrumb.model';
import {select, Store} from '@ngrx/store';
import {ActivatedRoute, Router} from '@angular/router';
import {Location} from '@angular/common';
import {take, takeUntil} from 'rxjs/operators';
import {Observable, Subject} from 'rxjs';
import {DynamicFieldItem} from '@shared/components/dynamic-form/dynamic-form-item';
import {ParticleService} from '@core/services/particle.service';
import {ParticleState} from '@shared/store/reducers/particle.reduer';
import {CommandService} from '@core/services/command.service';
import {SnackBarService} from '@core/services/snack-bar.service';
import {DialogService} from '@shared/services/dialog-service';
import {IQueryState} from '@shared/store/reducers/query.reducer';
import {getQueryResponse} from '@shared/store/selectors/query.selector';
import {QueryProvider} from '@shared/queries/query-provider';
import {getDialogAttachment} from '../../../task-manager/store/task-manager.selector';
import {Configuration} from '@shared/models/configuration';
import {ResetVirtualGridAction} from '@shared/store/actions/virtual-grid.actions';
import {TaskManagerState} from '../../../task-manager/store/task-manager.reducer';
import {TempAccessTokenService} from '@core/interceptors/auth.interceptor';
import {SetTempAccessTokenAction} from '@shared/store/actions/auth.actions';
import {SetDialogAttachmentAction} from '../../../task-manager/store/task-manager.action';
import {SaveFormFieldCommand} from '../../../dac6-reporter/commands/dac6-reporter.command';
import {
  AcceptResponseCommand,
  PrepareUserResponseCommand,
  RejectResponseCommand,
  SubmitResponseCommand
} from '../../commands/survey.commands';
import {DeleteQueryAction} from '@shared/store/actions/query.actions';
import {QueryModel} from '@shared/models/query-model';
import {SocketClusterService} from '@core/services/socket-cluster.service';
import {
  CollaborativeFormInteraction,
  IFormInteractionHelper,
  IndividualFormInteraction,
  ReviewerFormInteraction
} from './interaction-helper';
import { Guid } from 'guid-typescript';
import {ParticleCacheService} from "@core/services/particle-cache.service";
import {ParticleCacheModel} from "@shared/models/particle-cache.model";
import {SecurityState} from "@shared/store/reducers/security.reducer";
import {hasFeature} from "@shared/store/selectors/security.selector";

@Component({
    standalone: false,
    selector: 'particle-form',
  templateUrl: './form.component.html',
  styleUrls: ['./form.component.scss']
})
export class FormComponent implements OnInit , OnDestroy {

  sourceType: string;
  flag: boolean;
  invalidateSubject: InvalidateSubject;
  breadcrumbs: BreadcrumbModel[];
  breadcrumbs$: any;
  selectedFieldSectionIndex: number;
  endpointName: string;
  isProjectSpecific: boolean;
  showOriginal: boolean;
  autoSave: boolean;
  showDelete: boolean;
  showLanguageOption: boolean;
  item$: Observable<any>;
  item: any;
  isDirty: boolean;
  editedFields: string[] = [];
  containerClass: string;
  formField: DynamicFieldItem;
  formState$: any;
  unsubscibes$ = new Subject<void>();
  fieldConfig: any;
  totalChanges: number = 0;
  autoSaveInterval;
  public surveyExecutionId: string;
  attachment: any;
  public itemId: string;
  public userId: string;
  public surveyId: string;
  public executionId: string;
  public actualItemId: string;
  isReview: boolean;
  public response$: Observable<any>;
  public breadcrumbQueryModel: QueryModel;
  public hasSubscribedToSocketCluster: boolean;
  formInteractionHelper: IFormInteractionHelper;
  private response: any;
  private responseId: string;
  private responseStatus: string = '';
  isEmpty: boolean = false;
  private taskBoardId: string;
  private taskTicketId: string;
  private isVisitor: boolean;

  constructor(  public router: Router,
                public particleService: ParticleService,
                public particleStore: Store<ParticleState>,
                public commandService: CommandService,
                public activatedRoute: ActivatedRoute,
                public snackBarService: SnackBarService,
                public dialogService: DialogService,
                public queryState: Store<IQueryState>,
                private location: Location,
                public taskManagerStore: Store<TaskManagerState>,
                public tempAccessTokenService: TempAccessTokenService,
                public socketClusterService: SocketClusterService,
                private securityStore: Store<SecurityState>,
                private particleCacheService: ParticleCacheService
  ) {
    this.selectedFieldSectionIndex = 0;
    this.autoSave = false;
    this.showOriginal = false;
    this.showLanguageOption = true;
    this.invalidateSubject = new InvalidateSubject();
    this.containerClass = 'content';
    this.endpointName = 'DataSurveyApi';
    this.isDirty = false;
  }
  async canDeactivate() {
    let res = true;
    if(this.editedFields.length > 0){
      const question = 'You have unsaved changes. Do you want to save these changes before continuing?';
      const dialogRef = this.dialogService.showConfirmDialog('Unsaved Changes', 'Yes', 'No', null, question);
      dialogRef.pipe(takeUntil(this.unsubscibes$)).subscribe(data => {
        if (data.action === 'OK') {
          this.save();
          res = false;
        } else if(data.action === 'Closed'){
          res = false;
        }
      });
      await dialogRef.toPromise();
    }
    return res;
  }
  ngOnInit() {
    this.invalidateSubject.getObservale().pipe(takeUntil(this.unsubscibes$)).subscribe(state => {
      if (state.indexOf('SaveChangesOnPageChangeOrTab') >= 0) {
        if(this.editedFields.length > 0)this.save();
      }
    });
    if(this.activatedRoute.snapshot.queryParams && this.activatedRoute.snapshot.queryParams.ticketId){
      this.taskTicketId = this.activatedRoute.snapshot.queryParams.ticketId;
    }
    if(this.activatedRoute.snapshot.queryParams && this.activatedRoute.snapshot.queryParams.boardId){
      this.taskBoardId = this.activatedRoute.snapshot.queryParams.boardId;
    }
    this.activatedRoute.params.pipe(take(1),takeUntil(this.unsubscibes$)).subscribe((params: any) => {
      this.surveyExecutionId = params.executionId;
      this.userId = params.userId;
      this.createFormInteractionHelper();
      if (this.userId === 'review') {
        this.breadcrumbs = [
          <BreadcrumbModel>{
            id : 'DataSurvey',
            title: 'Data Survey',
            type: 'DataSurvey',
            relativeUrl: 'data-survey'
          }
        ];
        this.isReview = true;
        this.response$ = this.queryState.pipe(select(getQueryResponse, 'ResponseById'));
        this.response$.pipe(takeUntil(this.unsubscibes$)).subscribe(item => {
          console.log('This is a response', item);
          if (item && item.code) {
            this.response = item;
            this.breadcrumbQueryModel = QueryProvider.getQuery('BreadcrumbByResponseId');
            this.breadcrumbs$ = this.queryState.pipe(select(getQueryResponse, 'BreadcrumbByResponseId'));
            this.breadcrumbs$.pipe(takeUntil(this.unsubscibes$)).subscribe(state => {
              if (state) {
                this.breadcrumbs = state.breadcrumb;
              }
            });
            QueryProvider.invokeQuery(this.queryState, 'BreadcrumbByResponseId', {'[ID]': item.id});

            this.executionId = item.executionId;
            if (item.userExecutionId) {
              this.executionId = item.userExecutionId;
            }
            this.itemId = item.firstItemId;
            this.actualItemId = this.itemId;
            this.surveyExecutionId = this.executionId;
            this.getSurveyDataItem();
          }
        });
        QueryProvider.invokeQuery(this.queryState, 'ResponseById', {'[ResponseId]': this.surveyExecutionId});
      } else {
        this.openTaskAttachment();
      }
    });
    this.securityStore.pipe(select(hasFeature), takeUntil(this.unsubscibes$)).subscribe((features: any)=>{
      if(features){
        this.isVisitor = features('VISITOR')? true : false;
      }
    });
    this.autoSaveInterval = setInterval( () => {
      if (this.isDirty && this.autoSave) {
        this.save();
      }
    }, 30000);
  }

  private openTaskAttachment() {
    this.taskManagerStore.pipe(select(getDialogAttachment))
      .pipe(takeUntil(this.unsubscibes$)).subscribe(attachmentInfo => {
      if (attachmentInfo && attachmentInfo.attachment) {
        this.attachment = attachmentInfo.attachment;
        this.breadcrumbs = [
          <BreadcrumbModel>{
            id: 'DataSurvey',
            title: 'Data Survey',
            type: 'DataSurvey',
            relativeUrl: 'data-survey'
          }
        ];
        if (this.attachment.MetaData.SurveyDisplayId) {
          this.breadcrumbs.push(<BreadcrumbModel>{
            id: 'survey',
            title: this.attachment.MetaData.SurveyDisplayId,
            type: 'survey',
            relativeUrl: `data-survey/${this.attachment.MetaData.SurveyId}`
          });
        }
        this.breadcrumbs.push(<BreadcrumbModel>{
          id: 'attachment',
          title: this.attachment.AttachmentTitle,
          type: 'Attachment',
          relativeUrl: this.attachment.Url
        });
        this.actualItemId = this.attachment.MetaData.ItemId;
        this.itemId = this.actualItemId;
        this.surveyExecutionId = this.attachment.MetaData.ExecutionId;
        this.executionId = this.surveyExecutionId;
        this.surveyId = this.attachment.MetaData.SurveyId;
        if (this.userId) {
          this.commandService.executeCommand(new PrepareUserResponseCommand(this.surveyId, this.surveyExecutionId, this.attachment))
            .pipe(takeUntil(this.unsubscibes$)).subscribe(commandState => {
            if (commandState && commandState.Payload) {
              this.itemId = commandState.Payload.FirstItemId;
              this.executionId = commandState.Payload.UserExecutionId;
              this.responseId = commandState.Payload.Id;
              this.responseStatus = commandState.Payload.Status;
              this.getSurveyDataItem();
            }
          });
        } else {
          this.response$ = this.queryState.pipe(select(getQueryResponse, 'ResponseById'));
          this.response$.pipe(takeUntil(this.unsubscibes$)).subscribe(item => {
            console.log('This is a response', item);
            if (item && item.code) {
              this.response = item;
              this.responseStatus = this.response.status;
              this.responseId = this.response.id;
              this.getSurveyDataItem();
            }
          });
          QueryProvider.invokeQuery(this.queryState, 'ResponseById', {'[ResponseId]': this.attachment.MetaData.ResponseId});
        }
      } else {
        this.isEmpty = true;
      }
    });
  }
  private subscribeToSocketCluster(itemId) {
    if (!this.hasSubscribedToSocketCluster) {
      this.socketClusterService.subscribeToChannel(itemId, function(notification) {
        console.log('Notification received for item ' + itemId, notification);
        this.invokeGetFormRowResponse();
      }.bind(this));
      this.hasSubscribedToSocketCluster = true;
    }

  }
  private getSurveyDataItem() {
    this.item$ = this.queryState.pipe(select(getQueryResponse, this.itemId));
    this.item$.pipe(takeUntil(this.unsubscibes$)).subscribe(item => {
      if (item && item.cells) {
        if (!this.item) {
          this.item = item;
          this.subscribeToSocketCluster(this.item.id);
        }
        Object.keys(item.cells).forEach(key => {
          if (!this.item.cells[key]) {
            this.item.cells[key] = {};
          }
          this.item.cells[key].isDirty = false;
          this.item.cells[key].actualValue = item.cells[key].value;
          this.item.cells[key].value = item.cells[key].value;
          this.item.cells[key].displayText = item.cells[key].displayText;
        });
        this.editedFields.splice(0, this.editedFields.length);
        this.isDirty = false;
        if (!this.formState$) {
          this.getFormFieldConfiguration();
        } else {
          this.invalidateSubject.invalidate('Refresh|' + Guid.create().toString());
        }
      }
    });
    this.invokeGetFormRowResponse();
  }

  private getFormFieldConfiguration() {
    this.sourceType = this.item.cells['SourceType'].value;
    const formQueryKey = 'DynamicFormKey';
    const formQuery = {...QueryProvider.getQuery(formQueryKey)};
    formQuery.key = formQueryKey + this.sourceType;
    formQuery.api = 'DataSurveyApi';

    let formFieldCache = this.particleCacheService.getItem(formQuery.key);
    if (!formFieldCache || formFieldCache.version !== this.particleCacheService.getClientConfigVersion()) {
      QueryProvider.addConfig(formQuery.key, formQuery);
      this.formState$ = this.queryState.pipe(select(getQueryResponse, formQuery.key)).pipe(take(2));
      this.formState$.pipe(takeUntil(this.unsubscibes$)).subscribe(formState => {
        if (formState) {
          formFieldCache = new ParticleCacheModel();
          formFieldCache.version = this.particleCacheService.getClientConfigVersion();
          formFieldCache.value = formState;
          this.particleCacheService.saveItem(formQuery.key, formFieldCache);
          this.updateFormField(formState);
        }
      });
      QueryProvider.invokeQuery(this.queryState, formQuery.key, {'[SOURCE_TYPE]': this.item.cells['SourceType'].value});
    } else {
      this.updateFormField(formFieldCache.value);
    }
  }

  private updateFormField(formState) {
    this.formField = formState.formField;
    if (this.formField.viewType === 'Tab') {
      this.containerClass = 'content';
    } else {
      this.containerClass = 'content m-30';
    }
    this.fieldConfig = formState.fieldConfig;
    this.showLanguageOption = this.formField.hasLanguageOption;
    this.showOriginal = this.formField.defaultShowOriginalLanguage;
  }

  private invalidateLanguage() {
    this.invalidateSubject.invalidate(this.showOriginal ? 'Original' : 'Translated');
  }
  submitResponse() {
    const dialogModel: DialogModel = DialogModel.create(
      'Submit Response',
      'SubmitResponseComponent', {'status': this.responseStatus, 'description': '' },
      '600px',
      '700px'
    );
    this.dialogService.showOkCancelDialog(dialogModel).pipe(takeUntil(this.unsubscibes$)).subscribe(res => {
      console.log('here are the inputs', res);
      if (res.action === 'OK') {
        const command = new SubmitResponseCommand(this.formInteractionHelper.submitAction, this.surveyId, this.surveyExecutionId,
          this.executionId, res.data.input.status, this.responseId, res.data.input.description);
        this.commandService.executeCommand(command).pipe(takeUntil(this.unsubscibes$)).subscribe(commandState => {
          if (commandState) {
            this.responseStatus = commandState.Payload.Status;
            this.snackBarService.showInformation(`Response submitted successfully.`);
            // this.router.navigate(['.'], {relativeTo: this.activatedRoute.parent});
            if(this.isVisitor){
              this.router.navigate([`task-manager/team/card/${this.taskBoardId}/${this.taskTicketId}`]);
            }else{
              this.location.back();
            }
          }
        });
      }
    });
  }
  onValueChanged(event) {
    if (event && event.action === 'ValueChanged') {
      this.totalChanges += event.increment;
      this.dirtyChanged();
    }
  }
  private dirtyChanged() {
    if (this.totalChanges) {
      this.isDirty = true;
    } else {
      this.isDirty = false;
    }
  }

  ngOnDestroy(): void {
    if (this.autoSaveInterval) {
      clearInterval(this.autoSaveInterval);
    }
    this.unsubscibes$.next();
    this.unsubscibes$.complete();
    this.tempAccessTokenService.resetAccessToken();
    this.taskManagerStore.dispatch(new SetTempAccessTokenAction(null));
    this.taskManagerStore.dispatch(new SetDialogAttachmentAction(null));
    if (this.breadcrumbQueryModel && this.breadcrumbQueryModel.key) {
      this.queryState.dispatch(new DeleteQueryAction(this.breadcrumbQueryModel, null, null));
    }
    if (this.hasSubscribedToSocketCluster && this.itemId) {
      this.socketClusterService.unsubscribeChannel(this.itemId);
    }
  }

  export() {
    // TODO : add later
  }
  autoSaveChanged() {
    this.save();
  }
  acceptResponse() {
    this.dialogService.showTextAreaInputDialog('Accept Response', '', 'Comment')
      .pipe(takeUntil(this.unsubscibes$))
      .subscribe(state => {
        if (state.action === 'OK') {
          console.log('Accept comment', state);
          const command = new AcceptResponseCommand(this.response.id, state.data.input.text);
          this.commandService.executeCommand(command).pipe(takeUntil(this.unsubscibes$))
            .subscribe(commandStae => {
              this.snackBarService.showInformation(`You have accepted the response successfully`);
              const url = `data-survey/${this.response.surveyId}/${this.response.executionId}`;
              this.router.navigateByUrl(url);
            });
        }
      });
  }
  rejectResponse() {
    this.dialogService.showTextAreaInputDialog('Reject Response', '', 'Comment')
      .pipe(takeUntil(this.unsubscibes$))
      .subscribe(state => {
      console.log('Reject comment', state);
      const command = new RejectResponseCommand(this.response.id, state.data.input.text);
      this.commandService.executeCommand(command).pipe(takeUntil(this.unsubscibes$))
        .subscribe(commandStae => {
          this.snackBarService.showInformation(`You have rejected the response successfully`);
          const url = `data-survey/${this.response.surveyId}/${this.response.executionId}`;
          this.router.navigateByUrl(url);
        });
    });
  }
  save() {
      if (this.editedFields.length) {
        const item = {};
        item['id'] = this.item.id;
        if (this.item.cells['SourceItemId'] && this.item.cells['SourceItemId'].value) {
          item['sourceItemId'] = this.item.cells['SourceItemId'].value;
        }
        if (this.item.cells['ItemId'] && this.item.cells['ItemId'].value) {
          item['itemId'] = this.item.cells['ItemId'].value;
        }
        item['fieldValues'] = {};
        this.editedFields.forEach(fieldKey => {
          if (this.item.cells[fieldKey]) {
            item['fieldValues'][fieldKey] = this.item.cells[fieldKey].value;
          }
        });

        const command = new SaveFormFieldCommand(this.endpointName, item);
        this.formInteractionHelper.fixSaveFormFieldCommandEndpoint(command);
        this.commandService.executeCommand(command).pipe(takeUntil(this.unsubscibes$)).subscribe(commandState => {
          this.invalidateSubject.invalidate('SaveChanges|' + Guid.create().toString());
          this.totalChanges = 0;
          this.dirtyChanged();
        });
      }else{
        this.invalidateSubject.invalidate('SaveChanges|' + Guid.create().toString());
      }
  }

  private invokeGetFormRowResponse() {
    const formRowQueryKey = this.formInteractionHelper.formRowQueryKey;
    QueryProvider.invokeQueryByExecutionId(this.queryState, formRowQueryKey, this.itemId, {
      '[ID]': this.actualItemId,
      '[ExecutionId]': this.surveyExecutionId
    });
    this.totalChanges = 0;
    this.dirtyChanged();
  }

  showOriginalChanged() {
    this.invalidateLanguage();
  }

  private createFormInteractionHelper() {
    if (this.userId) {
      if (this.userId === 'review') {
        this.formInteractionHelper = new ReviewerFormInteraction(this);
      } else {
        this.formInteractionHelper = new IndividualFormInteraction(this);
      }
    } else {
      this.formInteractionHelper = new CollaborativeFormInteraction(this);
    }
  }

  compactViewType() {

  }

  navigateToTaskManager() {
    this.router.navigateByUrl('task-manager/card');
  }

  private transferIsExpandedState(oldFormField: DynamicFieldItem, newFormField: DynamicFieldItem) {

  }
}
